import {NotificationType} from '@domain/enum/notification-type.enum';

export class Notification
{
    public readonly id: string;

    public readonly date: Date;

    public readonly clinic: string;

    public readonly patient?: string;

    public readonly clinician?: string;

    public readonly type: NotificationType;

    public constructor(
        id: string,
        date: Date,
        clinic: string,
        type: NotificationType,
        patient?: string,
        clinician?: string
    )
    {
        this.id = id;
        this.date = date;
        this.clinic = clinic;
        this.type = type;
        this.patient = patient;
        this.clinician = clinician;
    }

    public static fromJSON(notificationJSON: Record<string, any>): Notification
    {
        return new Notification(
            notificationJSON.id,
            new Date(notificationJSON.date),
            notificationJSON.clinic,
            notificationJSON.type,
            notificationJSON.patient,
            notificationJSON.clinician
        );
    }
}
